import classNames from 'classnames';
import { CSSProperties, FC, ReactElement } from 'react';
import Icon from '../Icon/Icon';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from '~/constants/styles';
import './style.scss';

interface IProps {
  size?: number;
  color?: string;
  className?: string;
  iconClassName?: string;
  style?: CSSProperties;
}

const Spinner: FC<IProps> = ({ size = 24, color = theme.colors.mainblue, className, iconClassName }: IProps): ReactElement => {
  return (
    <div className={className}>
      <div className="spinner my-auto d-flex" style={{ width: size + 6, height: size + 6 }}>
        <Icon size={size} name={Icons.Spinner} className={classNames('spinner-icon', iconClassName)} style={{ color }} />
      </div>
    </div>
  );
};

export default Spinner;
